import { createContext, Dispatch, useCallback, useContext, useReducer } from 'react';
import {
    reducer,
    initialState,
    LayoutState,
    closeSidebar,
    openRightSidebar,
    openLeftSidebar,
    SidebarTypes
} from './services/baseLayout.reducer';

type BaseLayoutType = {
    state: LayoutState;
    dispatch: Dispatch<any>;
    onCloseSidebar: () => void;
    onSidebarOpen: (sidebarType: SidebarTypes, isRight?: boolean) => void;
};

const BaseLayoutContext = createContext({} as BaseLayoutType);

export function BaseLayoutProvider({ children }: AppCommonChild) {
    const [state, dispatch] = useReducer(reducer, initialState);

    const onCloseSidebar = useCallback(() => {
        dispatch(closeSidebar());
    }, [dispatch]);

    const onSidebarOpen = useCallback(
        (sidebarType: SidebarTypes, isRight = false) => {
            if (isRight) {
                dispatch(openRightSidebar({ sidebarType }));
            } else {
                dispatch(openLeftSidebar({ sidebarType }));
            }
        },
        [dispatch]
    );

    return (
        <BaseLayoutContext.Provider value={{ state, dispatch, onCloseSidebar, onSidebarOpen }}>
            {children}
        </BaseLayoutContext.Provider>
    );
}

export function useBaseLayoutState() {
    const { state } = useContext(BaseLayoutContext);
    if (!state) {
        throw new Error('Should use inside provider');
    }
    return state;
}
export function useBaseLayoutAction() {
    const { dispatch } = useContext(BaseLayoutContext);
    if (!dispatch) {
        throw new Error('Should use inside provider');
    }
    return dispatch;
}
export function useBaseLayoutCloseSide() {
    const { onCloseSidebar } = useContext(BaseLayoutContext);
    if (!onCloseSidebar) {
        throw new Error('Should use inside provider');
    }
    return onCloseSidebar;
}
export function useBaseLayoutOpenSide() {
    const { onSidebarOpen } = useContext(BaseLayoutContext);
    if (!onSidebarOpen) {
        throw new Error('Should use inside provider');
    }
    return onSidebarOpen;
}
